import state from './state'
export default {
  state,
  mutations: {
    setActiveThirdChannel(state, channel) {
        state.activeThirdChannel = channel
    },
    setConfirmThirdChannel(state, channel) {
        state.confirmThirdChannel = channel
    }
  },
  actions: {},
  getters: {}
}


// WEBPACK FOOTER //
// ./src/store/thirdResume/index.js